import { Observable } from 'rxjs';
import { AbstractControl, ValidationErrors } from '@angular/forms';
import { take } from 'rxjs/operators';

export function fileFormattingErrorValidator(hasFormattingError$: Observable<boolean>) {
  return (control: AbstractControl): ValidationErrors | null => {
    const files = control.value as File[] | null;
    if (!files?.length) return null;

    let error: ValidationErrors | null = null;
    hasFormattingError$.pipe(take(1)).subscribe(hasError => {
      if (hasError) {
        error = { formattingError: true };
      }
    });

    return error;
  };
}
